import React from 'react';
import { descriptionTemplate } from '../../TransactionsFacelift/components/cell-templates/transaction-description';
import { LiliTransaction } from '../../TransactionsFacelift/types/lili-transaction';
import { transactionStatus } from '../../TransactionsFacelift/components/cell-templates/transaction-status';
import { amountTemplate } from '../../TransactionsFacelift/components/cell-templates/transaction-amount';
import { testIdPrefix } from '../widgets/LatestTransactionsWidget/LatestTransactionsWidget';

interface TransactionRowProps {
  liliTransaction: LiliTransaction;
  onClick: (transaction: LiliTransaction) => void;
}

export const TransactionRow = ({ liliTransaction, onClick }: TransactionRowProps) => (
  <div
    onClick={() => onClick(liliTransaction)}
    tabIndex={0}
    role='button'
    onKeyDown={() => {}}
    key={liliTransaction.transactionId}
    className='w-full h-[64px] justify-center flex items-center border-b-[1px] border-bw03 last:border-0 hover:bg-bw01'
    data-testid={`${testIdPrefix}_table`}
  >
    <div className='w-[100px] font-metricR text-sm text-bw08 leading-5 px-[5px] shrink-0'>
      {new Date(liliTransaction.timestamp)
        .toLocaleString('en-US', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        })
        .split(',')}
    </div>
    <div className='w-[280px] flex grow font-metricR text-sm text-bw08 leading-5 px-[6px]'>
      {descriptionTemplate(liliTransaction)}
    </div>
    <div className='w-[150px] flex grow font-metricR text-sm text-bw08 leading-5 pl-[12px] pr-[20px]'>
      {transactionStatus(liliTransaction)}
    </div>
    <div className='w-[120px] font-metricR text-sm text-bw08 leading-5 px-[5px] text-right'>
      {amountTemplate(liliTransaction)}
    </div>
  </div>
);
